// Home turf: the player's own house. Light on purpose (types only), so the
// store can ask "is there a house to build around?" without importing the
// builders in ./index.
//
// Owner, 2026-09-27: "When user enters in an address as their town could you
// make the first house their own house they have to mow? And then fill in
// around them? rather than random centre of the postcode? Unless they only
// give a postcode then go to centre of postcode".

import type { HomeTurf } from './types';

/**
 * Did the player give their own address (a street and a number)? Then the
 * area is built around that point, their house is a yard, and it is the
 * first job. A suburb, a postcode or a street without a number is not.
 */
export function ownPlace(home: Pick<HomeTurf, 'street' | 'number'> | null | undefined): boolean {
  return !!home?.street?.trim() && !!home.number?.trim();
}

/** "Home · 12 Example St": the job's address line and card title. */
export function homeLine(home: Pick<HomeTurf, 'street' | 'number'>): string {
  return `Home · ${home.number?.trim()} ${home.street?.trim()}`;
}

/** A typed street address: a number first ("12 Example St", "3/12 Example St", "12-14 Example St"); group 2 is the house's number. */
export const TYPED_NUMBER = /^(?:(\d+[a-z]?)\s*\/\s*)?(\d+[a-z]?)(?:\s*-\s*\d+[a-z]?)?\s+\S/i;

/** Does this search start with a street number (a whole address typed in the one field)? */
export function typedAddress(q: string): boolean {
  return TYPED_NUMBER.test(q.trim());
}
